<script setup lang="ts" generic="T, MM">
import { Query } from '@/generated/graphql'
import { useQuery } from '@vue/apollo-composable'
import gql from 'graphql-tag'
import SelectField, { SelectOption } from '@/components/input/SelectField.vue'
import { computed } from 'vue'
import { itemSortByName } from '@/app'

const model = defineModel<T | undefined>()

const fetchQuery = useQuery<Query>(gql`
  query getStepTypesForPicker {
    product {
      stepTypes {
        id
        name
        archived
      }
    }
  }
`)
const options = computed<SelectOption<string>[]>(() =>
  itemSortByName(
    fetchQuery.result.value?.product.stepTypes.filter((t) => !t.archived),
    (t) => t.name,
  ).map((t) => ({
    title: t.name,
    value: t.id,
  })),
)
</script>

<template>
  <select-field v-model="model" :items="options" v-bind="$attrs" />
</template>

<style scoped lang="scss"></style>
